import {Button} from '@progress/kendo-react-buttons'
import { Grid, GridColumn, GridSortChangeEvent } from '@progress/kendo-react-grid'
import * as React from 'react'
import {connect} from 'react-redux'
import * as ReactStrap from 'reactstrap'
import * as Redux from 'redux'
import * as App from '../../app/types'
import { FlashMessage } from '../../components/flash-message'
// import * as IsActive from '../../components/is_active' // if we need active filter
import { Loading } from '../../components/loading'
import * as UserMenu from '../../components/menu/user-menu'
import * as RasaModal from '../../components/modal'
import * as Sortable from '../../components/sortable'
import * as FilterGroup from '../filter-group'
import * as GridCell from '../grid-cell'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Render from './render'
import './styles.css'
import * as Types from './types'

const {Row, Col} = ReactStrap

interface AppProps {
  app: App.State,
  filterGroups?: Types.WrappedState,
  helpText?: string,
}

interface HeaderProps {
  showAddFilterModal: RasaModal.Toggle,
}

const Header = ({app, filterGroups, showAddFilterModal, view}:
  AppProps & Types.WrappedState & HeaderProps & Types.WrappedViewState) =>
<div>
  <FlashMessage />
  <ReactStrap.Row className="margin-auto">
    <ReactStrap.Col sm="12" md="10" className="text-left page-header--padding">
      <div className="page-header">
        <span className="title">Filter Groups</span>
        <Button
          disabled={view.isLoading}
          className="secondary-button"
          onClick={showAddFilterModal}
          title="Add Filter Group">
          Add Filter Group
        </Button>
      </div>
    </ReactStrap.Col>
    {/* if we need active filter */}
    {/* <ReactStrap.Col sm="12" md="2">
      <div className="page-header--padding">
        <IsActive.FilterSelect view={view} event={Constants.FETCH_FILTER_GROUPS} disabled={view.isLoading}/>
      </div>
    </ReactStrap.Col> */}
  </ReactStrap.Row>
</div>

const HeaderConnect = connect(
  ({app, filterGroups}: AppProps & Types.WrappedState) => ({app, filterGroups}),
  ({
    showAddFilterModal: Actions.toggleAddFilterGroupModal,
  }),
)(Header)

interface DispatchProps {
  dispatch: Redux.Dispatch<Redux.Action>
}
type Props = Types.WrappedState & DispatchProps & UserMenu.WrappedState & App.WrappedState

const FilterGroupsGrid = ({filterGroups, dispatch, userMenu}: Props) =>
  <div>
  {filterGroups.data.length > 0 ?
        <Grid data={filterGroups.data}
              resizable={true}
              sortable={{
              allowUnsort: true,
              mode: 'single',
              }}
              sort={filterGroups.view.sort}
              onSortChange={(e: GridSortChangeEvent) => dispatch({
                            options: { value: e.sort },
                            type: Sortable.sortTableConstant(Constants.FETCH_FILTER_GROUPS),
              })}>
    <GridColumn cell={Render.ActiveAndEditCell} field="is_active" title="Active" width={75}/>
    <GridColumn field="name" title="Name" width={225}/>
    <GridColumn cell={Render.TagsCell} field="tags" title="Tags" width={375}/>
    <GridColumn field="source_count" title="Source Count" width={150}/>
    <GridColumn cell={GridCell.DateTimeCell} field="created_datetime" title="Created"/>
    <GridColumn cell={GridCell.DateTimeCell} field="updated_datetime" title="Updated"/>
  </Grid>
    : <div>No Filter Groups currently setup, please add one</div>}
</div>

const FilterGroupsGridConnected = connect(
  ({filterGroups, userMenu, app}: Props) => ({filterGroups, userMenu, app}),
  (dispatch: any) => ({dispatch}),
)(FilterGroupsGrid)

export const FilterGroups = ({filterGroups, dispatch, userMenu, app}: Props) =>
<div className="filterGroups-page">
  <ReactStrap.Row>
    <ReactStrap.Col>
      <HeaderConnect view={filterGroups.view}/>
    </ReactStrap.Col>
  </ReactStrap.Row>
  <div className="grid">
    {filterGroups.view.isLoading
      ?
        <Loading center size={Loading.Sizes.LARGE} />
      :
      <Row>
        <Col>
          <FilterGroupsGridConnected />
        </Col>
    </Row>
    }
  </div>
  <FilterGroup.UncontrolledCreateFilterModal
      modal={filterGroups.modalAddFilterGroup}
      showModal={() => dispatch(Actions.toggleAddFilterGroupModal())}
      submitModal={(communityId: string, data: FilterGroup.ModalData) =>
        dispatch(Actions.createFilterGroup(communityId, data))}
      updateModal={(f) => dispatch(Actions.updateAddFilterGroupModalField(f))} />
</div>

export const FilterGroupsConnected = connect(
  ({filterGroups, userMenu, app}: Props) => ({filterGroups, userMenu, app}),
  (dispatch: any) => ({dispatch}),
)(FilterGroups)



// WEBPACK FOOTER //
// ./src/pages/filter-groups/component.tsx